export const filtersInitialState = {
  priceSort: "",
  selectedCategory: [],
  priceSlider: 1500,
  ratingSlider: 1,
};
